var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEtcServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 89,
    viewBox: "0 0 97 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5938,
    y: 40.8027,
    width: 54.9563,
    height: 21.9825,
    transform: "rotate(-45.5529 16.5938 40.8027)",
    fill: "#3A7EFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9648,
    y: 39.1455,
    width: 8.79301,
    height: 26.379,
    rx: 0.800053,
    transform: "rotate(-45.5529 14.9648 39.1455)",
    fill: "#87B1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2578,
    y: 6.30762,
    width: 8.79301,
    height: 26.379,
    rx: 0.800053,
    transform: "rotate(-45.5529 47.2578 6.30762)",
    fill: "#87B1FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 37.7168,
    width: 10.9913,
    height: 61.5511,
    rx: 2.00013,
    transform: "rotate(-45.5529 44.9492 37.7168)",
    fill: "#3A7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03406 74.1835C2.07857 73.7778 2.42126 73.4707 2.82934 73.4707H44.9265C45.3346 73.4707 45.6773 73.7778 45.7218 74.1835L47.1585 87.2781C47.2105 87.7516 46.8396 88.1654 46.3632 88.1654H1.39264C0.916235 88.1654 0.545396 87.7516 0.597354 87.2781L2.03406 74.1835Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEtcServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcEtcServiceMainMobile.456c2ffebabb2bab140e72008c815aa9.svg";
export { ForwardRef as ReactComponent };